const config = {
  appName: 'Data Server',
  appShortName: 'DS',
  appVersion: process.env.VUE_APP_VERSION,
  apiUrl: process.env.VUE_APP_API_BASE_URL || '',
  enviromentServerUrl: 'http://localhost:9001',
  apiRequestTimeout: 30000,
};

export default config;
